import { render, staticRenderFns } from "./Career.vue?vue&type=template&id=70d97bfe&scoped=true"
import script from "./Career.vue?vue&type=script&lang=js"
export * from "./Career.vue?vue&type=script&lang=js"
import style0 from "./Career.vue?vue&type=style&index=0&id=70d97bfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d97bfe",
  null
  
)

export default component.exports